import { Zoom } from 'ol/control';
import { default as RControlBase } from './RControlBase';
/**
 * Zoom control
 *
 * Requires an `RMap` context
 */
export default class RZoom extends RControlBase {
    constructor(props) {
        super(props);
        this.ol = new Zoom(this.toOLProps(props));
    }
    toOLProps(props) {
        return Object.assign(Object.assign({}, super.toOLProps(props)), { duration: props.duration, zoomInLabel: props.zoomInLabel, zoomOutLabel: props.zoomOutLabel, zoomInTipLabel: props.zoomInTipLabel, zoomOutTipLabel: props.zoomOutTipLabel, delta: props.delta });
    }
}
//# sourceMappingURL=RZoom.js.map